//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { metaData } from '~/configuration/metaData';
import FCImage from '~/components/FCImage.vue';

export default {
  name: 'IdVerification',
  head: {
    ...metaData.idVerification,
  },
  components: {
    FCImage,
  },
  mounted() {
    const script = document.createElement('script');
    script.src = 'https://s3.amazonaws.com/idme/developer/idme-buttons/assets/js/idme-wallet-button.js';
    document.body.appendChild(script);

    script.onload = () => {
      if (window && typeof window.BindIDme === 'function') {
        // The script has fully loaded and can now call BindIDme function defined in the script
        window.BindIDme();
      }
    };
  },
};
